import { Role } from 'data/users';
import { FormProps } from './interface/form-props.interface';

export interface CreateEmployeeDTO {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  username: string;
  phoneNumber: string;
  roles: Role[] | Array<string>;
  verified: boolean;
  isAdmin?: boolean;
  isFieldOperator?: boolean;
  isCallOutUser?: boolean;
}

export class CreateEmployeeFormData {
  [key: string]: FormProps;

  email: FormProps = {
    name: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'staff@example.com'
  };
  firstName: FormProps = {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    placeholder: 'John'
  };
  lastName: FormProps = {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    placeholder: 'Doe'
  };
  password: FormProps = {
    name: 'password',
    label: 'Password',
    type: 'password',
    placeholder: 'Enter password'
  };
  username: FormProps = {
    name: 'username',
    label: 'Username',
    type: 'text',
    placeholder: 'john.doe'
  };
  phoneNumber: FormProps = {
    name: 'phoneNumber',
    label: 'Phone Number',
    type: 'tel',
    placeholder: '+1 (555) 555-5555',
    required: true,
    value: ''
  };
  roles: FormProps = {
    name: 'roles',
    label: 'Roles',
    type: 'select',
    placeholder: 'Select roles'
  };
  isAdmin: FormProps = {
    name: 'isAdmin',
    label: 'Make this employee an admin',
    type: 'checkbox',
    placeholder: 'Is Admin',
    renderAsCheckboxOnly: true
  };
  isFieldOperator: FormProps = {
    name: 'isFieldOperator',
    label: 'Make this employee a field operator',
    type: 'checkbox',
    placeholder: 'Is Field Operator',
    renderAsCheckboxOnly: true
  };
  isCallOutUser: FormProps = {
    name: 'isCallOutUser',
    label: 'Make this employee a Call-Out Cal user',
    type: 'checkbox',
    placeholder: 'Is Call-Out Cal User',
    renderAsCheckboxOnly: true,
    value: false
  };
}
